module.exports = __WEBPACK_EXTERNAL_MODULE_54__;


//////////////////
// WEBPACK FOOTER
// external {"root":"@material/slider/dist/mdc.slider","commonjs2":"@material/slider/dist/mdc.slider","commonjs":"@material/slider/dist/mdc.slider","amd":"@material/slider/dist/mdc.slider","umd":"@material/slider/dist/mdc.slider"}
// module id = 54
// module chunks = 0